module.exports = __webpack_public_path__ + "static/media/s_sf_1.4153b5f6.png";